import { LayoutGrid, List as ListIcon, GalleryHorizontal } from "lucide-react";
import { VIEW_SWITCH } from "@/constants/testIds";

const OPTIONS = [
  { key: "slider", label: "Slider", icon: GalleryHorizontal, testId: VIEW_SWITCH.slider },
  { key: "grid", label: "Grid", icon: LayoutGrid, testId: VIEW_SWITCH.grid },
  { key: "list", label: "List", icon: ListIcon, testId: VIEW_SWITCH.list },
];

export const ViewSwitcher = ({ view, onChange }) => (
  <div className="flex items-center gap-1 border border-[#2A2A2A] p-1" role="tablist" aria-label="Collection view mode">
    {OPTIONS.map((o) => (
      <button
        key={o.key}
        type="button"
        role="tab"
        aria-selected={view === o.key}
        aria-label={o.label}
        data-testid={o.testId}
        onClick={() => onChange(o.key)}
        className={`flex items-center justify-center w-10 h-10 sm:w-11 sm:h-11 transition-colors ${
          view === o.key ? "bg-[#CCFF00] text-black" : "text-[#888880] hover:text-[#F5F5F0]"
        }`}
      >
        <o.icon size={16} />
      </button>
    ))}
  </div>
);

export default ViewSwitcher;
